import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { qaroniAnimations } from '@qaroni-shared/animations/qaroni-animations';

@Component({
  selector: 'qaroni-title-status-chip',
  templateUrl: './title-status-chip.component.html',
  styleUrl: './title-status-chip.component.scss',
  animations: [qaroniAnimations.enterFadeIn()],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TitleStatusChipComponent {
  readonly status = input<string>('');
  readonly matTooltipText = input<string>('');
  readonly bgClassColorName = input<string>('qaroni-bg-primary80');
}
